import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithDesignsGalleyWithHealthProvider, useDesignsGalleryHealth] = createComponentHealth('StationeryDesignsGallery');
